import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { ApiStatus } from "src/app/models/api";
import { Form1095EmailCriteria, Form1095Item, Form1095Model } from "src/app/models/form-1095";
import { TableColumn } from "src/app/models/table";
import { DocumentService } from "src/app/services/documents.service";
import { HelperService } from "src/app/services/helper.service";
import { EmailDocumentDialogModel, } from "src/app/models/dialog";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { DialogEmailDocumentComponent } from "../../shared/dialog/email-document.component";
import { EmailDialogType } from "src/app/constants/email-dialog-type";

@Component({
    selector: "mwp-form-1095",
    templateUrl: "./form-1095s.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberDocumentForm1095sComponent implements OnInit {
    public apiUrl = ContentHeaderKey.DocumentsForm1095;
    public form1095List: Form1095Item[];
    public apiStatus = new ApiStatus();

    public form1095sMatTableData: MatTableDataSource<Form1095Item>;
    public form1095sColumns: TableColumn[] = [
        {
            columnName: 'File Name',
            propertyId: 'fileName',
            columnType: TableColumnType.label,
            width: '25%'

        },
        {
            columnName: 'Year',
            propertyId: 'year',
            columnType: TableColumnType.label,
            width: '28%'
        },
        {
            columnName: 'Actions',
            propertyId: 'fileType',
            columnType: TableColumnType.button,
            dataTypeText: "Download",
            width: '11%',

        },
        {
            columnName: '',
            propertyId: 'form1095ID',
            columnType: TableColumnType.button,
            dataTypeText: "Email",
            isButtonSelection2: true,
            width: '11%',

        },

    ];
    constructor(
        private documentService: DocumentService,
        private helperService: HelperService,
        private dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        this.documentService.getForm1095s().subscribe((response: Form1095Model) => {
            this.form1095sMatTableData = new MatTableDataSource<Form1095Item>();
            this.form1095sMatTableData.data = response.form1095Items;
        });
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }

    public downloadForm1095(form1095Item: Form1095Item): void {
        this.documentService.getForm1095Download(form1095Item.form1095ID).subscribe((response: Blob) => {
            let l_BinaryData = [];
            l_BinaryData.push(response);
            this.helperService.downloadDocument(l_BinaryData, response.type, `${form1095Item.fileName}${form1095Item.fileType}`);
        }
        );
    }

    public emailDocument(form1095Item: Form1095Item) {
        const dialogRef = this.dialog.open(DialogEmailDocumentComponent, {
            data: EmailDialogType.form1095,
            panelClass: 'mwp-modal-override-800'
        });

        dialogRef.afterClosed().subscribe((response: EmailDocumentDialogModel) => {
            if (response != null) {
                const l_EmailForm1095Criteria = new Form1095EmailCriteria();
                l_EmailForm1095Criteria.form1095ID = form1095Item.form1095ID;
                l_EmailForm1095Criteria.toAddress = response.email;
                this.documentService.sendForm1095ToEmail(l_EmailForm1095Criteria).subscribe(() => { });
            }
        });
    }
}
